export class ApiClientError extends Error {
    constructor(message, status, response) {
        super(message);
        this.status = status;
        this.response = response;
        this.name = 'ApiClientError';
    }
}
//# sourceMappingURL=types.js.map